import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { WrapSection, BlockWrapper } from './mobileToolBar.styled';

const MobileToolBar = props => {
  return (
    <WrapSection>
      {props.configList.map((obj, i) => {
        if (
          typeof obj.isVisibleMobile !== 'undefined' &&
          obj.isVisibleMobile === false
        )
          return null;

        if (obj.isVisible) {
          return (
            <BlockWrapper
              key={obj.tooltip + i}
              onClick={obj.onClick}
              mobileCustomScale={obj.mobileCustomScale}
              isActive={obj.isActive}
            >
              <Icon name={obj.icon} viewBox={obj.viewBox} />
            </BlockWrapper>
          );
        }

        return null;
      })}
    </WrapSection>
  );
};

MobileToolBar.propTypes = {
  configList: PropTypes.arrayOf(PropTypes.object),
};

export default MobileToolBar;
